
/**
 * 리뷰 요약 정보
 */
export type GetCourseReviews200ContentItem = {
  /** 리뷰 내용 */
  content: string;
  /** 강의 ID */
  courseId: string;
  /** 작성일시 */
  createdAt: string;
  /** 도움됨 투표 수 */
  helpful?: number;
  /** 리뷰 ID */
  id: string;
  /** 구매 확인된 리뷰 여부 */
  isVerifiedPurchase?: boolean;
  /**
   * 평점 (1-5)
   * @minimum 1
   * @maximum 5
   */
  rating: number;
  /** 학생 프로필 이미지 URL */
  studentAvatarUrl?: string;
  /** 학생 ID */
  studentId: string;
  /** 학생 이름 */
  studentName: string;
  /** 리뷰 태그 */
  tags?: string[];
  /** 리뷰 제목 */
  title?: string;
  /** 도움안됨 투표 수 */
  unhelpful?: number;
  /** 수정일시 */
  updatedAt?: string;
};
